export const errorHelper = ({ errorId, isInvalid }) => (
  isInvalid ? { 'aria-describedby': errorId, 'aria-invalid': isInvalid } : {}
)
